import { render, staticRenderFns } from "./MTextHorizontal.vue?vue&type=template&id=0abf1fb0&"
import script from "./MTextHorizontal.vue?vue&type=script&lang=js&"
export * from "./MTextHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports